module.exports = __webpack_public_path__ + "static/img/WhxKECPNujWoWEFNdnJE.e101e665.png";